import { useEffect } from "react";
import { isLocal } from "@/config/prefs";

export function InjectGoogleTagManager() {
  useEffect(() => {
    if (isLocal) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        if (d.getElementById("gtm-script")) return;
        j.id = "gtm-script";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-N6HFSBJN");
    `;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      const gtmScript = document.getElementById("gtm-script");
      if (gtmScript) gtmScript.remove();
    };
  }, []);

  return null;
}
